module.exports = __webpack_public_path__ + "img/img-73.16df948f.png";